import { httpClient } from "@/shared/services/http";

export class TestInstructionsHttpService {
  static async getTestInstructionsByTestId(testId: number): Promise<Record<string, string>> {
    const { data } = await httpClient.get(`/api/test-instructions?testId=${testId}`);

    return data[testId];
  }

  static async updateTestInstructionsBody(testId: number, body: Record<string, string>) {
    const { data } = await httpClient.put(`/api/test-instructions/${testId}/update-body`, body);

    return data;
  }
}
